import styled from 'styled-components/macro';

export const Container = styled.div<{ rounded?: boolean; size?: string }>`
  border-radius: ${({ rounded }) => (rounded ? '50%' : '6px')};
  align-items: center;
  background: #e7efee;
  display: flex;
  justify-content: center;
  min-width: ${({ size }) => size || '50px'};
  min-height: ${({ size }) => size || '50px'};
`;

export const StyledFirstLetterEmail = styled.div`
  color: #65aaa3;
  font-family: var(--font-family-base);
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px;
  letter-spacing: 0px;
  text-align: center;
`;

const FirstLetterEmail: React.FC<{ email: string; rounded?: boolean; size?: string }> = ({
  email,
  rounded,
  size,
}) => (
  <Container rounded={rounded} size={size}>
    {email && <StyledFirstLetterEmail>{email.toUpperCase().charAt(0)}</StyledFirstLetterEmail>}
  </Container>
);

export default FirstLetterEmail;
